import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../store/authStore';
import { getTenantFromToken } from '../lib/auth';

export function TenantBanner() {
  const { t } = useTranslation();
  const { token, selectedTenant, switchToTokenTenant } = useAuthStore();

  if (!token) return null;

  const tokenTenant = getTenantFromToken(token);
  if (!tokenTenant || tokenTenant === selectedTenant) return null;

  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
      <div className="flex items-center justify-between">
        <div className="flex">
          <div className="flex-shrink-0">
            <span className="text-yellow-400 text-xl">⚠️</span>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-700">
              {t('tenant.mismatch')}
            </p>
            <p className="text-xs text-yellow-600 mt-1">
              {t('tenant.label')}: <span className="font-mono">{selectedTenant}</span> → <span className="font-mono">{tokenTenant}</span>
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button
            onClick={switchToTokenTenant}
            className="inline-flex items-center px-3 py-1 border border-yellow-400 rounded-md text-xs font-medium text-yellow-700 bg-yellow-100 hover:bg-yellow-200 transition-colors"
          >
            {t('tenant.switch')}
          </button>
        </div>
      </div>
    </div>
  );
}
